import { TRANSPORTATION_MODE } from '@helpers/types/order';
import {
  awbDataSchema,
  blDataSchemaSea,
  blDataSchemaRailRoad
} from '@helpers/yup/order-tasks.schema';

type ModeConfig = {
  taskName: 'AWB' | 'BL';
  schema: any;
  defaultValues: Record<string, unknown>;
};

export const TRANSPORT_CONFIG: Record<TRANSPORTATION_MODE, ModeConfig> = {
  AIR: {
    taskName: 'AWB',
    schema: awbDataSchema,
    defaultValues: {
      awb_service_name: '',
      awb_date: null,
      awb_number: ''
    }
  },
  SEA: {
    taskName: 'BL',
    schema: blDataSchemaSea,
    defaultValues: {
      bl_date: null,
      bl_number: '',
      bl_type: null
    }
  },
  RAIL: {
    taskName: 'BL',
    schema: blDataSchemaRailRoad,
    defaultValues: {
      bl_date: null,
      bl_number: '',
      bl_document: undefined
    }
  },
  ROAD: {
    taskName: 'BL',
    schema: blDataSchemaRailRoad,
    defaultValues: {
      bl_date: null,
      bl_number: '',
      bl_document: undefined
    }
  }
};
